import { ApisauceInstance } from 'apisauce';

/**
 * Reads a bonus dataset record's ad-hoc recognition payments, the policy (caps)
 * enforced on them and what is left under it. `policy` is null when the
 * program has not enabled additional payments. Allowed in every period status.
 */
const getAdditionalPayments = ({
  api,
  bonusDatasetRecordId,
}: {
  api: ApisauceInstance;
  bonusDatasetRecordId: string;
}) => {
  return api.get<
    BonusTypes.AdditionalPayments.Response,
    BonusTypes.AdditionalPayments.ErrorResponse
  >(
    `/v1/driver_bonus/additional_payments?bonus_dataset_record_id=${bonusDatasetRecordId}`,
  );
};

export default getAdditionalPayments;
